/** Learner auth storage keys and public paths. */

export const LEARNER_ACCESS_TOKEN_KEY = "student_access_token"
export const LEARNER_REFRESH_TOKEN_KEY = "student_refresh_token"
export const LEARNER_INFO_KEY = "student_info"

export const LEARNER_LOGIN_PATH = "/learner/login"
export const LEARNER_DEFAULT_PATH = "/learner/dashboard"

export const LEARNER_SESSION_CLEARED_EVENT = "learner:session-cleared"
export const LEARNER_SESSION_UPDATED_EVENT = "learner:session-updated"
